import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=37fc5650&scoped=true"
import script from "./Alert.js?vue&type=script&lang=js&external"
export * from "./Alert.js?vue&type=script&lang=js&external"
import style0 from "./Alert.scss?vue&type=style&index=0&id=37fc5650&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc5650",
  null
  
)

export default component.exports